import React from "react";
import { Table } from "react-bootstrap";
import { useSelector } from "react-redux";
import classnames from "classnames";

const TableData = () => {
  const { graph } = useSelector((state) => state.workbook.workbook);

  return (
    <Table responsive>
      <thead>
        <tr>
          <th className="border-0 bg-transparent p-1 fw-normal">Stock Trade</th>
          <th className="border-0 bg-transparent p-1 fw-normal">Price</th>
          <th className="border-0 bg-transparent p-1 fw-normal">Change(%)</th>
        </tr>
      </thead>

      <tbody>
        {graph.map((item) => (
          <tr key={item._id}>
            <td className="border-0 bg-transparent p-1">
              <div className="d-flex align-items-center">
                <span className="icn me-2">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="10"
                    height="10"
                    viewBox="0 0 10 10"
                    fill="none"
                  >
                    <path
                      d="M9.7 4.4C9.55 3.85 9.55 3.85 9.35 3.35L6.35 3.3L5.4 0.5H4.3L3.3 3.3L0.35 3.35C0.2 3.9 0.2 3.9 0 4.4L2.4 6.2L1.5 9.05L2.4 9.7L4.85 8L7.3 9.7C7.75 9.35 7.75 9.4 8.2 9.05L7.3 6.2L9.7 4.4Z"
                      fill="#202020"
                    />
                  </svg>
                </span>
                <p className="m-0">{item.name}</p>
              </div>
            </td>

            <td className="border-0 bg-transparent p-1">
              <p className="m-0">{item.close}</p>
            </td>

            <td className="border-0 bg-transparent p-1">
              <p
                className={classnames("m-0", {
                  "text-danger": Math.sign(item.change) === -1,
                  "text-success": Math.sign(item.change) === 1,
                })}
              >
                {Number(item.change).toFixed(2)}%
              </p>
            </td>
          </tr>
        ))}
      </tbody>
    </Table>
  );
};

export default React.memo(TableData);
